import React from "react";
import {
  LocationOn,
  Email,
  HeadsetMic,
  Smartphone,
  Facebook,
  Twitter,
  LinkedIn,
} from "@mui/icons-material";

export function LandingFooter() {
  return (
    <footer className="bg-crimson py-10 text-[#F8F8FF]">
      <div className="mx-auto max-w-6xl px-4">
        {/* Grid container for two columns */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
          {/* Branding & Social Icons */}
          <div>
            <h3 className="text-xl font-semibold">Nepal Can TMS</h3>
            <p className="mt-4 text-sm">Smart Transport, Swift Deliveries. </p>
            <div className="mt-4 flex space-x-4">
              <a
                href="https://www.facebook.com/"
                aria-label="Facebook"
                className="hover:text-gray-400"
              >
                <Facebook className="h-8 w-8" fontSize="large" />
              </a>
              <a
                href="https://x.com"
                aria-label="X (Twitter)"
                className="hover:text-gray-400"
              >
                <Twitter className="h-8 w-8" fontSize="large" />
              </a>
              <a
                href="https://www.linkedin.com"
                aria-label="LinkedIn"
                className="hover:text-gray-400"
              >
                <LinkedIn className="h-8 w-8" fontSize="large" />
              </a>
            </div>
          </div>

          {/* Contact Information */}
          <div className="md:ml-auto">
            <h4 className="mb-4 text-lg font-semibold">Contact</h4>
            <ul className="space-y-3 text-sm">
              {/* Location */}
              <li className="flex items-start">
                <LocationOn className="mr-2 mt-1 !h-5 !w-5" />
                <span>
                  Nepal Can Code Building, 51 Muni Bhairab Marga, Tinkune,
                  Kathmandu
                </span>
              </li>

              {/* Email */}
              <li className="flex items-center">
                <Email className="mr-2 !h-5 !w-5" />
                <span>support@nepalcancode.com</span>
              </li>

              {/* Call Center */}
              <li className="flex items-center">
                <HeadsetMic className="mr-2 !h-5 !w-5" />
                <span>(CALL CENTER) +977 15970736</span>
              </li>

              {/* Mobile */}
              <li className="flex items-center">
                <Smartphone className="mr-2 !h-5 !w-5" />
                <span>(NCELL) 9709155366</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="mt-8 border-t border-[#F8F8FF] pt-4 text-center text-sm">
          &copy; 2025 Nepal Can Code. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
